// extracted by mini-css-extract-plugin
export default {"PropertyBlock":"PropertyBlock_PropertyBlock__CHtcl","IconsBlock":"PropertyBlock_IconsBlock__aGIU6","TimeLine":"PropertyBlock_TimeLine__6h5PX"};